import classes from "./Home.module.css"

function Home() {
	return (
		<div className={classes.home}>
			<p>
				This is my portfolio where I showcase my game development related projects. Although I focus on programming, due to the multimedia nature of video games, I believe pictures and descriptions do them more justice than a repository with code.
			</p>
			<p>
				For my other coding projects, you can visit my Github profile (link in the top left). There I have a variety of projects, most of them focused on low level programming.
			</p>
			<p>
				Most of the projects on this website have a downloadable build, so you can try them out yourself. I hope you enjoy them!
			</p>
		</div>
	);
}

export default Home;
